<template>
    <span>
        <span v-if="participant.ogrn || participant.inn">
            <card-link :ogrn="participant.ogrn || participant.inn">
                {{participant.title}}
            </card-link>
            <tooltip class="on-one-row no_print" :ogrn="participant.ogrn || participant.inn" />
        </span>
        <span v-else>{{participant.title}}</span>
    </span>
</template>

<script>
import cardLink from '@/components/ui/cardLink.vue'
import tooltip from '@/components/ui/tooltip.vue'

export default {
    props: {
        participant: Object
    },
    components: {
        cardLink,
        tooltip
    }
}
</script>

<style lang="sass" scoped>
.on-one-row
    display: inline
</style>
